import { NgClass } from '@angular/common';
import {Component, Inject} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-buyer-delete',
  imports: [
    FormsModule,
    MatDialogActions,
    MatDialogContent,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './buyer-delete.html',
  styleUrl: './buyer-delete.css'
})
export class BuyerDelete {

  constructor(public dialogRef: MatDialogRef<BuyerDelete>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  close(): void {
    this.dialogRef.close(false)
  }

  delete(): void {
    this.dialogRef.close(true)
  }
}
